import OrangeInside from '../modules/orangeInside.js'
import { SG1Logs } from '../modules/logs.js'

export const orangeInsideOrchestrator = () => {
   window.displayOrangeInside = () => {
      try {
      let orangeInsideTpl = document.getElementById('orange-inside')
      if (orangeInsideTpl === null) throw `L'élément '#orange-inside' n'existe pas`
      let orangeInsideOpts = {}
      let orangeInside = new OrangeInside()
      orangeInside.display(orangeInsideTpl, orangeInsideOpts)
      } catch (error) {
         console.error('OrangeInside Orchestrator', error)
         SG1Logs.incLog('Err_CORCH')
         SG1Logs.sentryEvent({ error: error, name: 'OrangeInside Orchestrator' })
      }
   }
}
